import { render, staticRenderFns } from "./core_list.vue?vue&type=template&id=f125dfc2&scoped=true"
import script from "./core_list.vue?vue&type=script&lang=js"
export * from "./core_list.vue?vue&type=script&lang=js"
import style0 from "./core_list.vue?vue&type=style&index=0&id=f125dfc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f125dfc2",
  null
  
)

export default component.exports